import { useMutation } from "@tanstack/react-query";
import { postUser } from "../api/admin";

const usePostUser = () => {
  const mutation = useMutation({ mutationFn: postUser });
  return mutation;
};

export default usePostUser;
